/* German locals for flatpickr */
var Flatpickr = Flatpickr || { l10ns: {} };
Flatpickr.l10ns.de = {};

Flatpickr.l10ns.de.weekdays = {
	shorthand: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
	longhand: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
};

Flatpickr.l10ns.de.months = {
	shorthand: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
	longhand: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
};

Flatpickr.l10ns.de.firstDayOfWeek = 1;
Flatpickr.l10ns.de.weekAbbreviation = 'KW';

if (typeof module !== "undefined") {
	module.exports = Flatpickr.l10ns;
}


//////////////////
// WEBPACK FOOTER
// ./~/flatpickr/dist/l10n/de.js
// module id = 12
// module chunks = 0